import { createStyles, makeStyles } from '@material-ui/core';
import { theme } from '@saesa/ui-kit-front';

const DisclaimerPecStyles = makeStyles(() =>
  createStyles({
    raiz: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: 12,
      boxSizing: 'border-box',
      width: '100%',
      padding: '16px 20px',
      backgroundColor: '#FFF0F3',
      border: '1px solid #CB0126',
      borderRadius: 10,
      flexShrink: 0,
    },
    raizColapsada: {
      alignItems: 'flex-start',
      padding: '12px 16px',
    },
    icono: {
      width: 24,
      height: 24,
      flexShrink: 0,
    },
    textos: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      minWidth: 0,
      flex: 1,
    },
    filaTitulo: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      width: '100%',
    },
    botonChevron: {
      display: 'none',
      marginLeft: 'auto',
      padding: 0,
      border: 'none',
      background: 'transparent',
      cursor: 'pointer',
      flexShrink: 0,
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
      },
    },
    chevron: {
      display: 'block',
      width: 18,
      height: 9,
    },
    chevronAbierto: {
      transform: 'rotate(180deg)',
    },
    tituloHome: {
      margin: 0,
      fontFamily: 'Neutrif Studio',
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '20px',
      color: '#060709',
    },
    textoHome: {
      margin: 0,
      fontFamily: 'Neutrif Studio',
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '18px',
      color: '#060709',
    },
    tituloDetalle: {
      margin: 0,
      fontFamily: 'Neutrif Studio',
      fontWeight: 600,
      fontSize: 18,
      lineHeight: '24px',
      color: '#060709',
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
        lineHeight: '20px',
      },
    },
    textoDetalle: {
      margin: 0,
      fontFamily: 'Neutrif Studio',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '20px',
      color: '#060709',
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
        lineHeight: '18px',
      },
    },
  })
);

export default DisclaimerPecStyles;
